module.exports = __webpack_public_path__ + "media/Capture the Moment (Screenshot Break).541ded03.mp3";